import { render, staticRenderFns } from "./resultTip.vue?vue&type=template&id=55d4e058&scoped=true"
import script from "./resultTip.vue?vue&type=script&lang=js"
export * from "./resultTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4e058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d4e058')) {
      api.createRecord('55d4e058', component.options)
    } else {
      api.reload('55d4e058', component.options)
    }
    module.hot.accept("./resultTip.vue?vue&type=template&id=55d4e058&scoped=true", function () {
      api.rerender('55d4e058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/route/trunkLineManagement/component/resultTip.vue"
export default component.exports